import { render, staticRenderFns } from "./WareDelivery.vue?vue&type=template&id=2abbfd97"
import script from "./WareDelivery.vue?vue&type=script&lang=js"
export * from "./WareDelivery.vue?vue&type=script&lang=js"
import style0 from "./WareDelivery.vue?vue&type=style&index=0&id=2abbfd97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports